module.exports = __webpack_public_path__ + "static/media/kaaba.30e5f911.svg";